export default __webpack_public_path__ + "static/media/select_item_icon.42a6f970.svg";